// app/components/layout/navigation/ConditionalHamburgerIcon.tsx
'use client';

import React from 'react';
import { usePathname } from 'next/navigation';
import FixedHamburgerIcon from './FixedHamburgerIcon';

export default function ConditionalHamburgerIcon() {
  const pathname = usePathname();

  // Split pathname by "/" and filter out any empty segments.
  const segments = pathname.split('/').filter(Boolean);
  // Example:
  // If the URL is "/en/voor-talenten/vacatures/abc123",
  // then segments = ['en', 'voor-talenten', 'vacatures', 'abc123'].
  //
  // We'll assume that a single vacancy page has exactly 4 segments and the third one is "vacatures".
  const isSingleVacancy = segments.length === 4 && segments[2] === 'vacatures';
  const isApplyPage = segments.length === 5 && segments[2] === 'vacatures' && segments[4] === 'solliciteren';

  if (isSingleVacancy || isApplyPage) return null;

  return <FixedHamburgerIcon />;
}
